/* IMPORT */
import channel from './channel.js';
/* MAIN */
const saturation = (color) => {
    return channel(color, 's');
};
/* EXPORT */
export default saturation;
